import type SignalFilters from "../models/core/SignalFilters";
import type UISignal from "../models/view/UISignal";
import type { SignalByIdMap, UITranslatedSignal } from "../types/extended-models";

import { translateUISignal } from "./translateUISignal";

export function translateSignalsToMapById(signals: readonly UISignal<SignalFilters>[]): SignalByIdMap {
    const map = new Map<string, UITranslatedSignal>();

    for (const uiSignal of signals) {
        map.set(uiSignal.id, translateUISignal(uiSignal));
    }

    return map;
}
